import React from 'react';

import { Button } from '../Button';
import { Icon } from '../Icon';

import type { WhisperboxProps } from './Whisperbox.types';

export const Whisperbox = ({
  text,
  content,
  button,
}: WhisperboxProps): JSX.Element => {
  return (
    <div className='whisperbox'>
      <div className='whisperbox__message'>
        {text && <p className='text-lead_2'>{text}</p>}
        {content && <p>{content}</p>}
        <div className='whisperbox__link'>
          {button && <Button {...button} />}
        </div>
      </div>
      <div className='whisperbox__go'>
        {button && (
          <a
            href={button.href}
            className='button button_icon'
            aria-hidden='true'
          >
            <Icon icon='Go32' size='xlarge' />
          </a>
        )}
      </div>
    </div>
  );
};
